import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobal } from "reactn";
import MediaQuery from "components/MediaQuery";
import GridBlock from "components/Champions/GridBlock";
import { SummonerSpell } from "@outplayed/tooltips";
import { getPercetange, numberWithCommas } from "lib/general-helper";

const SummonerSpells = (props) => {
  const { t } = useTranslation();
  const [language] = useGlobal("language");
  const [windowBreakpoint] = useGlobal("responsive");
  const { recSummonerSpells } = props;
  const isMobile = windowBreakpoint === "MOBILE_SMALL" || windowBreakpoint === "MOBILE_MEDIUM";

  return (
    <div className="content-section_content summoner-spells">
      <div className="content-section_header">
        <div>{t("Summoner Spells")}</div>
        <div className="wr-matches">
          <span className={"win-rate"}>{`${getPercetange(recSummonerSpells.wins, recSummonerSpells.matches, 2)}% WR `}</span>
          <MediaQuery min="DESKTOP_MEDIUM" max="DESKTOP_LARGE">
            <span className="matches">{`(${numberWithCommas(recSummonerSpells.matches)} Matches)`}</span>
          </MediaQuery>
        </div>
      </div>
      <div className="flex">
        <SummonerSpell spellId={recSummonerSpells.items[0]} ssr language={language} webp />
        <SummonerSpell spellId={recSummonerSpells.items[1]} ssr language={language} webp />
      </div>
    </div>
  );

  // return (
  //   <GridBlock
  //     classNames="summoner-spells"
  //     title={isMobile ? "Spells" : "Summoner Spells"}
  //     wins={recSummonerSpells.wins}
  //     matches={recSummonerSpells.matches}
  //   >
  //     <React.Fragment>
  //       <div className="image-wrapper"><SummonerSpell spellId={recSummonerSpells.items[0]} ssr /></div>
  //       <div className="image-wrapper"><SummonerSpell spellId={recSummonerSpells.items[1]} ssr /></div>
  //     </React.Fragment>
  //   </GridBlock>
  // )
  // return (
  //   <GridBlock
  //     classNames="summoner-spells"
  //     title={isMobile ? "Spells" : "Summoner Spells"}
  //     wins={recSummonerSpells.wins}
  //     matches={recSummonerSpells.matches}
  //   >
  //     <React.Fragment>
  //       <div className="image-wrapper"><SummonerSpell spellId={recSummonerSpells.items[0]} ssr /></div>
  //       <div className="image-wrapper"><SummonerSpell spellId={recSummonerSpells.items[1]} ssr /></div>
  //     </React.Fragment>
  //   </GridBlock>
  // )
};

export default SummonerSpells;
